// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { DeedType } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "../../../types";
import type { IGetDeedTypesParams, IPutDeedTypesParams, IPostDeedTypesParams } from "./DeedTypes";
import {
	createGetMethod,
	createGetByUidMethod,
	createPutMethod,
	createPostMethod,
	createDeleteMethod,
} from "./helpers/deedTypesMethodsHelpers";

interface DeedTypesInstance {
	get(q: IGetDeedTypesParams): Promise<DeedType[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<DeedType>;
	put(uid: string, body: IPutDeedTypesParams): Promise<DeedType>;
	post(body: IPostDeedTypesParams): Promise<DeedType>;
	delete(uid: string): Promise<DeedType>;
}

// Module-level singleton instance
let instance: DeedTypesInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createDeedTypes(): DeedTypesInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}

	const baseAdmin = baseAdminInstance;
	const baseUrl = baseAdmin.namespaceUrl.concat("/deed-types");

	return {
		get: createGetMethod(baseAdmin, baseUrl),
		getByUid: createGetByUidMethod(baseAdmin, baseUrl),
		put: createPutMethod(baseAdmin, baseUrl),
		post: createPostMethod(baseAdmin, baseUrl),
		delete: createDeleteMethod(baseAdmin, baseUrl),
	};
}

export function getDeedTypesInstance(): DeedTypesInstance {
	if (!instance) {
		instance = createDeedTypes();
	}
	return instance;
}
